import React from 'react';
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import {useMutation, useQuery} from "@apollo/client";
import {InstalledBaseNodeAttributeTDAs} from "../../graphql/queries/installedBaseNodeAttributeTDAs";
import {UpdateInstalledBaseNodeAttribute} from "../../graphql/mutations/updateInstalledBaseNodeAttribute";
import {toast} from "react-toastify";
import {Box} from "@mui/system";
import { Grid } from '@mui/joy';
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";

interface Props {
    attributeId: string
}

const AttributeInformation = ({attributeId}: Props) => {
    const {t} = useTranslation();

    const {data} = useQuery(InstalledBaseNodeAttributeTDAs, {variables: {id: attributeId}});

    const [updateAttributeMutation] = useMutation(UpdateInstalledBaseNodeAttribute)

    const attributes = _.get(data, 'installedBaseNodePropertyDefinition.typeDefinitionAttributeList.typeDefinitionAttributes', []);

    const handleUpdate = (input: any) => {
        return updateAttributeMutation({
            variables: {
                id: attributeId,
                input: input
            },
            refetchQueries: ["InstalledBaseNodeAttributeName", "InstalledBaseNodeAttributeTDAs"]
        }).then((res) => {
            toast.success(t('Updated attribute ') + res?.data?.updateInstalledBaseNodePropertyDefinition?.preferredName)
        }).catch((err) => {
            toast.error(resolveErrorMessage(err, t))
        })
        ;
    }

    return (
        <Grid container spacing={2} direction="row" padding={'24px'}>
            <Grid xs={12} lg={6}>
                <Box maxWidth={'600px'} flexGrow={1}>
                    <InstalledBaseTDAForm
                        attributes={attributes}
                        onSubmit={handleUpdate}
                        submitButtonText={t('Update Attribute')}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}

export default AttributeInformation;
